import { render } from "./etStatusTag.vue?vue&type=template&id=bc18818e"
import script from "./etStatusTag.vue?vue&type=script&lang=js"
export * from "./etStatusTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__